import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExportParameter } from '../../../../../Model/exportParameter/ExportParameter';
import { ModelService } from '../../../../../Services/model.service';
import { PimLicense } from '../../../../../Model/User/PimLicense';

@Component({
  selector: 'exportConfiguration',
  templateUrl: './exportConfiguration.component.html',
  styleUrls: ['./exportConfiguration.component.css']
})
export class ExportConfigurationComponent implements OnInit {
  @Input() exportParameter: ExportParameter;

  bmeDialects = ['NexMart', 'E/D/E Multishop', 'E/D/E Multishop no root', 'Onventis', 'Scireum', 'HUBWOO',"ETIM5"];
  imageTypes = ['jpg', 'png'];

  constructor(public modelService: ModelService, public translate: TranslateService) {
    this.bmeDialectChanged = this.bmeDialectChanged.bind(this);
  }

  ngOnInit(): void {}

  public bmeDialectChanged() {
    if (this.exportParameter.bmeDialect == 'Scireum') {
      this.exportParameter.useMediaUrl = true;
    }
  }

  get isScireum() {
    return this.exportParameter.version == 'SCIREUM';
  }
  get isOnboarding() {
    return this.modelService.loginService.hasAddonONBOARDING;
  }

  get showExportBrandNameAsTechnicalFeature() {
    var result = this.exportParameter.version == 'SCIREUM' ||
      this.exportParameter.version == 'SYMBIONET' ||
      this.exportParameter.version == 'WESCALE' ||
      this.exportParameter.version == 'GEVIS' ||
      this.exportParameter.version == 'ELECTRONIC_SALES' ||
      this.exportParameter.version == 'SMARTSTORE';
    return result;
  }
}
